import { createFileRoute } from '@tanstack/react-router'
import { NotificationConfig } from '../../../../features/admin/NotificationConfig'

/* ───── Route Definition ───── */

export const Route = createFileRoute(
  '/_authenticated/admin/monitoring/notifications',
)({
  component: AdminMonitoringNotificationsRoute,
})

/* ───── Route Component ───── */

function AdminMonitoringNotificationsRoute() {
  return <NotificationConfig />
}
